import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "@environments/environment";
import {RedirectionUrlResponse} from "../models/redirection-url-response";
import {GwoJsonResponse} from "../models/gwo-json-response";

@Injectable()
export class LauncherService {

  private get baseApiUrl(): string {
    return `${environment.launcherApiUrl}`;
  }

  constructor(private httpClient: HttpClient) {
  }

  public getRedirectionUrl$(mhbAccessHash: string): Observable<RedirectionUrlResponse> {
    return this.httpClient.get<GwoJsonResponse<RedirectionUrlResponse>>
    (`${this.baseApiUrl}/run/${mhbAccessHash}?json=true`).pipe(map(response => response.data));
  }

}
